export default __webpack_public_path__ + "static/media/plan4-col4-img.53d1dc54.svg";